<template>
    <div class="orderDetail">
<!--        <el-card class="noprint">-->
<!--            <el-page-header v-if="from == 'rfq'" @back="goBack" :content="'订单详情('+ orderId + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品采购</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单详情</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <div style="text-align: right;padding-bottom: 10px" >
                <el-button v-if="showBtn"
                           size="mini"  @click="passIt(orderId,step,workflowId,name,totalPrice)"
                        type="primary">通过</el-button>
                <el-button v-if="showBtn"
                           size="mini"  @click="showReviewDialog(orderId,step,workflowId,name,totalPrice,true)"
                        type="primary">驳回</el-button>
<!--                <el-button size="min"  @click="printOrder" type="primary">打印</el-button>-->
            </div>
            <el-card>
                <div style="margin-bottom: 10px;">采购原因：{{ submitReason }}</div>
                 <el-table
                    :data="proData"
                    v-loading="loading"
                    border
                    class="tableBaseInfo"
                    style="width: 100%;border-bottom: none !important;">
                     <el-table-column prop="sku" label="商品编码" fixed="left" width="150"/>
                     <el-table-column label="产品名称" width="200">
                        <template slot-scope="scope">
                             ({{scope.row.supplier}}) {{scope.row.shortName ? scope.row.shortName : scope.row.name}}
                         </template>
                     </el-table-column>
                     <el-table-column prop="brand" label="品牌" align="center" width="160"/>
                     <el-table-column prop="model" label="规格型号" align="center" width="160"/>
                     <el-table-column prop="num" label="数量" align="center" width="120">
                         <template slot-scope="scope">
                             {{scope.row.unit === null ? scope.row.num+'件' : scope.row.num+scope.row.unit}}
                         </template>
                     </el-table-column>
                     <el-table-column
                        min-width="160"
                        prop="untaxedPrice"
                        label="未税单价(元)"
                        align="center">
                            <template slot-scope="scope">
                                {{scope.row.untaxedPrice}}
                            </template>
                     </el-table-column>
                    <el-table-column
                        min-width="160"
                        prop="price"
                        label="含税单价(元)"
                        align="center">
                        <template slot-scope="scope">
                            {{scope.row.price}}
                        </template>
                    </el-table-column>
                     <el-table-column
                        min-width="160"
                             prop="totalUntaxedPrice"
                             label="未税总价(元)"
                             align="center">
                         <template slot-scope="scope">
                             {{scope.row.totalUntaxedPrice}}
                         </template>
                     </el-table-column>
                    <el-table-column
                        min-width="160"
                        prop="totalPrice" label="含税总价(元)" align="center">
                        <template slot-scope="scope">
                            {{scope.row.totalPrice}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right" prop="status" label="状态" align="center">
                         <template slot-scope="scope">
                             <el-tag v-if="scope.row.status == 0">待下单</el-tag>
                             <el-tag v-if="scope.row.status == 2">已下单</el-tag>
                             <el-tag v-if="scope.row.status == 3">已发货</el-tag>
                             <el-tag v-if="scope.row.status == 4">已收货</el-tag>
                             <el-tag v-if="scope.row.status == 7">驳回</el-tag>
                         </template>
                     </el-table-column>
                     <el-table-column prop="orderMemo" label="提报订单备注" width="auto" :min-width="200"/>
                     <el-table-column label="操作" align="center" fixed="right" v-if="showBtn" width="160">
                         <template slot-scope="scope">
                             <el-button type="text"
                                     size="mini" v-if="scope.row.status == 0"
                                     @click="showReviewDialog(scope.row.id,step,workflowId,
                                    name,scope.row.totalPrice,false)"
                                     >驳回</el-button>
                             <el-button type="text"
                                     size="mini" v-if="scope.row.status == 0"
                                     @click="showNum(scope.row)"
                                     >修改</el-button>

                         </template>
                     </el-table-column>

                </el-table>

<!--                <div style="text-align: center;padding-top: 20px">-->
<!--                    <el-pagination-->
<!--                        background-->
<!--                        layout="prev, pager, next"-->
<!--                        v-if="total>0"-->
<!--                        :total="total"-->
<!--                        :page-size="pageSize"-->
<!--                        @current-change="onPageChange"-->
<!--                        @prev-click="onPageChange"-->
<!--                        @next-click="onPageChange">-->
<!--                    </el-pagination>-->
<!--                </div>-->


            </el-card>
        </main>
        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="reviewForm" :model="reviewForm"  label-width="100px">
                <el-form-item label="审核结果" prop="pass"  v-if="false" size="mini">
                    <el-select v-model="reviewForm.pass" placeholder="" >
                        <el-option label="通过" value="true"></el-option>
                        <el-option label="拒绝" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reason" v-if='reviewForm.pass == "false"' size="mini">
                    <el-input v-model="reviewForm.reason" placeholder="请输入驳回原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="addProcess()" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改数量" :visible.sync="numVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="itemForm" :model="itemForm" :rules="rules"  label-width="100px">
                <el-form-item label="数量" prop="num" size="mini">
                    <el-input size="small"
                              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                              v-model="itemForm.num"
                              maxlength="8"
                              clearable><template slot="append">{{itemForm.unit}}</template></el-input>
<!--                    <el-input-number  v-model="itemForm.num"-->
<!--                              :precision="0" :step="1" :min="1" placeholder="请输入数量"></el-input-number>-->
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="numVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="editIt()" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data() {
        return {
            id:"",
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            reviewVisible:false,
            numVisible:false,
            reviewForm: {
                name:"",//收货人
                pass:true,
                reason: "",
                workflowId:"",
                step:"",
                orderId:"",
                totalPrice:"",
                price:"",
                all:true//整个订单 false :单条订单
            },
            itemForm: {
                detailId:"",//
                workflowId:"",
                step:"",
                orderId:"",
                num:"",
                oldNum:"",
                unit:"件"
            },
            infoData:{},
            invoiceData: [],//发票信息
            deliverData: [],//发票及货物接收信息
            orderData:[],//销售订单
            taxData: [],//含税价格
            proData: [],//产品信息
            submitReason: "",
            rules: {
                num: [
                    {required: true, message: '请输入数量', trigger: 'blur'}
                ],
            }
        }
    },
    props: ["from", "orderId","step","workflowId","name","totalPrice","showBtn"],

    methods: {
        onSearch() {
            const url = "/admin/rfq/orderDetail";
            this.loading = true
            if(this.orderId) {
                this.loading = true;
                let _this = this
                this.$axios.post(url,{
                    cond:{orderId:this.orderId},
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                }).finally(() => {
                    _this.loading = false;
                });
            }
        },
        info() {
            const url = "/admin/rfq/orderInfo";
            if(this.orderId) {
                this.loading = true;
                let _this = this
                this.$axios.post(url,{orderId:this.orderId}).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.infoData = resp.data;
                        _this.proData = _this.infoData.orderDetails;
                        _this.submitReason = resp.data.order.reason;

                        _this.orderData = [{name: "客户编号：",nameValue: _this.infoData.company.code},
                            {name: "客户名称：",nameValue: _this.infoData.company.name},
                            {name: "订单日期：",nameValue: _this.infoData.order.createTime},
                            {name: "订单联系人：",nameValue: _this.infoData.order.consignee},
                            {name: "订单状态：",nameValue: _this.infoData.order.showStatus}];
                        if(_this.infoData.order.status == 6){
                            _this.orderData = [{name: "客户编号：",nameValue: _this.infoData.company.code},
                                {name: "客户名称：",nameValue: _this.infoData.company.name},
                                {name: "订单日期：",nameValue: _this.infoData.order.createTime},
                                {name: "订单联系人：",nameValue: _this.infoData.order.consignee},
                                {name: "订单状态：",nameValue: _this.infoData.order.showStatus},
                                {name: "驳回原因：",nameValue: _this.infoData.rejectOrderReason}];
                        }

                        _this.taxData = [{name: "商品未税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalUntaxedPrice+"元"},
                            {name: "商品含税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalPrice+"元"}];

                        let invoice =
                            {
                                label1: "公司名称：",
                                v1: _this.infoData.company==null?'-':_this.infoData.company.name,
                                label2: "发票类型：",
                                v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.showType,
                            }
                        let invoice2 =
                            {
                                label1: "开户银行：",
                                v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankName,
                                label2: "注册电话：",
                                v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredTel,
                            }
                        let invoice3 =
                            {
                                label1: "银行账号：",
                                v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankAccount,
                                label2: "注册地址：",
                                v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredAddress,
                            }
                        let invoice4 =
                            {
                                label1: "公司税号：",
                                v1:  _this.infoData.invoice==null?'-':_this.infoData.invoice.companyTaxNo,
                                label2: "备注信息：",
                                v2: '-',
                            }
                            let d2 = [invoice,invoice2,invoice3,invoice4];

                        _this.invoiceData = d2;

                        let invoice5 =
                            {
                                label1: "发票接收地址：",
                                v1:  _this.infoData.order.province+ _this.infoData.order.city + _this.infoData.order.county + _this.infoData.order.address,
                                label2: "货物接收地址：",
                                v2:  _this.infoData.order.province+ _this.infoData.order.city + _this.infoData.order.county + _this.infoData.order.address,
                            }
                        let invoice6 =
                            {
                                label1: "接收人：",
                                v1:  _this.infoData.order.consignee,
                                label2: "手机：",
                                v2:  _this.infoData.order.mobile,
                            }
                        _this.deliverData = [invoice5,invoice6];

                    }
                }).catch(function() {
                });
            }
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        goBack() {
            this.$router.go(-1);
        },
        passIt(orderId,step,workflowId,name,totalPrice){

            this.reviewForm.pass = 'true';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;

            if(this.reviewForm.step == undefined) {
                this.reviewForm.step = step;
                this.reviewForm.workflowId = workflowId;
            }

            this.reviewForm.all = true;//整体审核
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.addProcess();
        },
        showReviewDialog(orderId,step,workflowId,name,totalPrice,all) {//打开审核对话框
            this.reviewForm.pass = 'false';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;

            if(this.reviewForm.step == undefined) {
                this.reviewForm.step = step;
                this.reviewForm.workflowId = workflowId;
            }

            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;

            this.reviewForm.all = all;
            this.reviewVisible = true;

        },
        showNum(row) {

            this.itemForm.detailId = row.id;
            this.itemForm.orderId =  this.orderId;
            this.itemForm.num =  row.num;
            this.itemForm.oldNum =  row.num;

            this.itemForm.unit = row.unit === null ? '件':row.unit;
            this.itemForm.step = this.step;
            this.itemForm.workflowId = this.workflowId;
            this.numVisible = true;

        },
        addProcess() {//添加审核过程
            if(!this.reviewForm.all){
                this.reject();
                return;
            }

            const that = this;
            let cond = {...this.reviewForm};

            let optate = "通过";
            optate = cond.pass == 'false' ? "驳回" : "通过";
            this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {

                cond.pass = cond.pass == 'true' ? true : false;
                if (cond.pass) {
                    cond.reason = '';
                }
                cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                    ,workflowId:cond.workflowId};
                this.$axios.post("/admin/rfq/review", cond)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            that.reviewVisible = false;
                            that.getStep(that.reviewForm.orderId);
                            if (resp.data == true) {//审核完毕
                                that.changeOrder(that.reviewForm.orderId);
                                // that.info();
                            } else {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                // that.info();
                            }
                            that.info();
                            // that.infoOrder();

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            });

        },
        reject() {//单条拒绝
            const that = this;
            let cond = {...this.reviewForm};

            this.$axios.post("/admin/product/order/check", {orderId:this.orderId,detailId:cond.orderId,num:0})
                .then(response => {
                    const resp = response.data;
                    if(resp.header.status == 0) {
                        let optate = "通过";
                        optate = cond.pass == 'false' ? "驳回" : "通过";
                        this.$confirm('确定' + optate +'【' +cond.name+'】提交的价格【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确认',
                            cancelButtonText: '取消'
                        }).then(() => {
                            cond.pass = cond.pass == 'true' ? true : false;
                            if (cond.pass) {
                                cond.reason = '';
                            }
                            cond={pass:cond.pass,reason:cond.reason,orderId:this.orderId,step:cond.step
                                ,workflowId:cond.workflowId,detailId:cond.orderId};
                            this.$axios.post("/admin/rfq/reviewItem", cond)
                                .then(function (response) {
                                    let resp = response.data;
                                    if (resp.header.status == 0) {
                                        that.reviewVisible = false;

                                        that.$notify({
                                            title: '成功',
                                            message: '数据保存成功',
                                            type: 'success'
                                        });
                                        that.info();
                                        that.getStep(that.orderId);
                                        // that.infoOrder();
                                    } else {
                                        that.$notify.error({
                                            title: '错误',
                                            message: resp.header.msg
                                        });
                                    }
                                });
                        });
                    } else {
                        let optate = "通过";
                        optate = cond.pass == 'false' ? "驳回" : "通过";
                        this.$confirm(`${resp.header.msg}</br>确定${optate}【${cond.name}】提交的价格【￥${cond.totalPrice}】的订单吗？`, '提示', {
                            dangerouslyUseHTMLString: true,
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确认',
                            cancelButtonText: '取消'
                        }).then(() => {
                            cond.pass = cond.pass == 'true' ? true : false;
                            if (cond.pass) {
                                cond.reason = '';
                            }
                            cond={pass:cond.pass,reason:cond.reason,orderId:this.orderId,step:cond.step
                                ,workflowId:cond.workflowId,detailId:cond.orderId};
                            this.$axios.post("/admin/rfq/reviewItem", cond)
                                .then(function (response) {
                                    let resp = response.data;
                                    if (resp.header.status == 0) {
                                        that.reviewVisible = false;

                                        that.$notify({
                                            title: '成功',
                                            message: '数据保存成功',
                                            type: 'success'
                                        });
                                        that.info();
                                        that.getStep(that.orderId);
                                        // that.infoOrder();
                                    } else {
                                        that.$notify.error({
                                            title: '错误',
                                            message: resp.header.msg
                                        });
                                    }
                                });
                        });
                    }
                });


        },
        changeOrder(orderId) {//修改状态为下单
            const that = this;
            this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {

                        if(resp.data == true){//审核完毕
                            that.$notify({
                                title: '成功',
                                message: '已下单',
                                type: 'success'
                            });
                        }

                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        getStep(orderId) {//获得新的审核步骤
            const that = this;
            this.$axios.post("/admin/rfq/getStep", {orderId:orderId,
                step:this.reviewForm.step,workflowId:this.reviewForm.workflowId})
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        if( resp.data.review){
                            that.reviewForm.step = resp.data.step;
                            that.reviewForm.workflowId = resp.data.workflowId;
                            that.step = resp.data.step;
                            that.workflowId = resp.data.workflowId;

                            that.showBtn = true;

                        }else {
                            that.showBtn = false;
                        }


                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        printOrder(){
           this.$bus.$emit('menuClose',true);
           this.$print(this.$refs.detailTable);
        },

        hiddenHeaderRow({ rowIndex }) {
            if (rowIndex == 1) {
                //隐藏第二行
                return "hiddenClass";
            }
        },
        hiddenHeaderRow0({ rowIndex }) {
            if (rowIndex > 0) {
                //隐藏第二行
                return "hiddenClass";
            }
        },
        // 合并客户基本信息表格客户名称单元格
        arraySpanMethod1({ rowIndex, columnIndex }) {
            if (rowIndex == 0) {
                if (columnIndex != 0) {
                    return [1, 2];
                }
            }
        },
        tableHeaderColor ({ rowIndex, columnIndex }) {
            if (rowIndex === 0 && columnIndex === 0) {
                return { background:'#dfdfdf',fontSize:'14px',color:'black'}
            } else if (rowIndex === 0 && columnIndex !== 0) {
                return { background: '#dfdfdf', border: '1',color:'black'}
            } else {
                return { background: '#dfdfdf'}
            }
        },
        //columnStyle( {row, column, rowIndex, columnIndex}) {
            columnStyle( { columnIndex}) {

                //第一三列
                if (columnIndex == 0 || columnIndex == 2) {
                    //字体颜色
                    return {background:'#dfdfdf',fontWeight:'bold',color:'black'};
                }
            return {fontSize:'14px',color:'black'};

        },
        columnStyleO() {
            return {fontSize:'14px',color:'black'};

        },
        editIt(){
            let that = this;
            let cond = {...this.itemForm};

            this.$refs.itemForm.validate(valid => {
                if (valid) {
                    if(this.itemForm.oldNum == this.itemForm.num) {
                        that.$notify({
                            title: '提示',
                            message: '请修改商品数量',
                            type: 'info'
                        });
                        return;
                    }

                    // 检查是否需要加收运费
                    this.$axios.post("/admin/product/order/check", {orderId:this.orderId,detailId:this.itemForm.detailId,num:this.itemForm.num})
                    .then(response => {
                        const resp = response.data;
                        if(resp.header.status == 0) {
                            // 不需要加收运费时
                            let msg = "确认修改商品数量为"+cond.num + cond.unit;
                            this.$confirm(msg+'吗？', '提示', {
                                distinguishCancelAndClose: true,
                                confirmButtonText: '确认',
                                cancelButtonText: '取消'
                            }).then(() => {
                                cond={
                                    orderId:this.orderId,
                                    step:this.step,
                                    workflowId:this.workflowId,
                                    detailId:this.itemForm.detailId,
                                    num:this.itemForm.num
                                };
                                this.$axios.post("/admin/rfq/editNum", cond)
                                    .then(function (response) {
                                        let resp = response.data;
                                        if (resp.header.status == 0) {

                                            that.numVisible = false;
                                            if (resp.data == true) {//修改数量完毕

                                                that.$notify({
                                                    title: '成功',
                                                    message: '数据保存成功',
                                                    type: 'success'
                                                });
                                                that.info();
                                                // that.infoOrder();
                                            }


                                        } else {
                                            that.$notify.error({
                                                title: '错误',
                                                message: resp.header.msg
                                            });
                                        }
                                    });
                            });
                        } else if(resp.header.status == 2){
                            // 需要加收运费时
                            let msg = "确认修改商品数量为"+cond.num + cond.unit;
                            this.$confirm(`${resp.header.msg}</br>${msg}吗？`, '提示', {
                                dangerouslyUseHTMLString: true,
                                distinguishCancelAndClose: true,
                                confirmButtonText: '确认',
                                cancelButtonText: '取消'
                            }).then(() => {
                                cond={
                                    orderId:this.orderId,
                                    step:this.step,
                                    workflowId:this.workflowId,
                                    detailId:this.itemForm.detailId,
                                    num:this.itemForm.num
                                };
                                this.$axios.post("/admin/rfq/editNum", cond)
                                    .then(function (response) {
                                        let resp = response.data;
                                        if (resp.header.status == 0) {

                                            that.numVisible = false;
                                            if (resp.data == true) {//修改数量完毕

                                                that.$notify({
                                                    title: '成功',
                                                    message: '数据保存成功',
                                                    type: 'success'
                                                });
                                                that.info();
                                                // that.infoOrder();
                                            }


                                        } else {
                                            that.$notify.error({
                                                title: '错误',
                                                message: resp.header.msg
                                            });
                                        }
                                    });
                            });
                        } else {
                            this.$confirm(`${resp.header.msg}`, '提示', {
                                dangerouslyUseHTMLString: true,
                                distinguishCancelAndClose: false,
                                showCancelButton: false,
                                confirmButtonText: '确认',
                            });
                        }
                    });
                }
            });
        },
        infoOrder() {
            const url = "/admin/rfq/orderInfo";
            if (this.orderId) {
                this.loading = true;
                let _this = this
                this.$axios.post(url, {orderId: this.orderId}).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.infoData = resp.data;
                        _this.totalPrice = _this.infoData.order.totalPrice;
                    }
                });
            }
        }


    },
    created() {

        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }

        const { workflowId, name, step,totalPrice,orderId } =  JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.orderId = orderId;
        this.reviewForm.orderId = orderId;

        this.reviewForm.step = step;
        this.reviewForm.workflowId = workflowId;
        this.reviewForm.name = name;
        this.reviewForm.totalPrice = totalPrice;

        //this.showBtn = showBtn;
        //this.onSearch();
        this.info();


    },


}
</script>
<style lang="scss" scoped>
    // .tableBaseInfo{
    //     font-size: 13px !important;
    // }


</style>